import moment from "moment";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";

import { PLANNER_ORDER_DIRECTION, PLANNER_ORDER_NAME, PLANNER_ORDER_TEXT } from "../helpers/planner_order";

export const usePlannerDefaultOrder = () => {
  const { formatISODate } = useDateFormatter();

  return {
    direction: PLANNER_ORDER_DIRECTION,
    end_date: formatISODate(moment().add(1, "months")),
    name: [...PLANNER_ORDER_NAME],
    start_date: formatISODate(),
    text: PLANNER_ORDER_TEXT
  };
};
